var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.25 45.0784L18.75 45.0784C9.56249 45.0784 6.77082 42.4509 6.77082 33.8039L6.77082 14.196C6.77082 5.54896 9.56249 2.92151 18.75 2.92151L31.25 2.92151C40.4375 2.92151 43.2292 5.54896 43.2292 14.196L43.2292 33.8039C43.2292 42.4509 40.4375 45.0784 31.25 45.0784ZM18.75 5.86269C11.2917 5.86269 9.89582 7.19602 9.89582 14.196L9.89582 33.8039C9.89582 40.8039 11.2917 42.1372 18.75 42.1372L31.25 42.1372C38.7083 42.1372 40.1042 40.8039 40.1042 33.8039L40.1042 14.196C40.1042 7.19602 38.7083 5.86269 31.25 5.86269L18.75 5.86269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.1667 12.7255L20.8333 12.7255C19.9792 12.7255 19.2708 12.0588 19.2708 11.2549C19.2708 10.451 19.9792 9.7843 20.8333 9.7843L29.1667 9.7843C30.0208 9.7843 30.7292 10.451 30.7292 11.2549C30.7292 12.0588 30.0208 12.7255 29.1667 12.7255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 39.4117C22.3542 39.4117 20.2083 37.3921 20.2083 34.9019C20.2083 32.4117 22.3542 30.3921 25 30.3921C27.6458 30.3921 29.7917 32.4117 29.7917 34.9019C29.7917 37.3921 27.6458 39.4117 25 39.4117ZM25 33.3137C24.0833 33.3137 23.3333 34.0195 23.3333 34.8823C23.3333 35.745 24.0833 36.4509 25 36.4509C25.9167 36.4509 26.6667 35.745 26.6667 34.8823C26.6667 34.0195 25.9167 33.3137 25 33.3137Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4a94dfe5f8b0491a0efbe3e851d2aef0.svg";
export { ForwardRef as ReactComponent };